
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import OrderRepository from '@/repositories/webshop/OrderRepository';
import { Sort, SortDirection } from '@/repositories/BaseCrudRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class OrderListScreen extends Vue {
    @Inject()
    private readonly orderRepository!: OrderRepository;

    public get initialSort(): Sort[] {
        return [
            {
                property: 'id',
                direction: SortDirection.DESC,
            },
        ];
    }

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.order.id'),
                align: 'left',
                value: 'id',
                sortable: true,
            },
            {
                text: this.$t('crud.order.surname'),
                align: 'left',
                value: 'surname',
                sortable: true,
            },
            {
                text: this.$t('crud.order.status'),
                value: 'statusVerbose',
                sortable: true,
            },
            {
                text: this.$t('crud.order.paymentStatus'),
                value: 'paymentStatusVerbose',
                sortable: true,
            },
            {
                text: this.$t('crud.order.paymentMethod'),
                value: 'paymentMethodVerbose',
                sortable: false,
            },
            {
                text: this.$t('crud.order.molliePaymentId'),
                value: 'molliePaymentId',
                sortable: true,
            },
            {
                text: this.$t('crud.order.date'),
                value: 'createdAt',
                sortable: true,
            },
            {
                text: this.$t('crud.order.totalPrice'),
                value: 'totalPrice',
                sortable: false,
            },
        ];
    }
}
